import React, { useEffect, useState } from "react";
import { X, BarChart3 } from "lucide-react";
import { blogApi } from "../api";

const SEEN_KEY = "dscr_weekly_seen";

export default function WeeklyPopup() {
  const [post, setPost] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timer;
    blogApi.latest().then((p) => {
      if (!p) return;
      const marker = p.week || p.published_at || p.id;
      if (localStorage.getItem(SEEN_KEY) === marker) return;
      setPost(p);
      timer = setTimeout(() => setOpen(true), 4000);
    }).catch(() => {});
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    if (post) localStorage.setItem(SEEN_KEY, post.week || post.published_at || post.id);
    setOpen(false);
  };

  if (!open || !post) return null;

  return (
    <div onClick={dismiss} data-testid="weekly-popup" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(6px)", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: "1.5rem", animation: "fadeIn 0.3s ease" }}>
      <div onClick={(e) => e.stopPropagation()} className="card" style={{ background: "#0f0e13", width: "100%", maxWidth: 560, maxHeight: "82vh", overflowY: "auto", padding: "2.6rem", position: "relative", borderColor: "rgba(201,162,75,0.35)" }}>
        <button onClick={dismiss} data-testid="close-weekly-popup" style={{ position: "absolute", top: 18, right: 18, background: "none", border: "none", color: "var(--muted)", cursor: "pointer" }}><X size={20} /></button>
        <div style={{ display: "flex", alignItems: "center", gap: "0.7rem", marginBottom: "1rem" }}>
          <span style={{ color: "var(--gold)" }}><BarChart3 size={18} /></span>
          <span className="eyebrow" style={{ fontSize: "0.62rem", color: "var(--gold)" }}>This Week · {post.tag || "Market Update"}</span>
        </div>
        <h2 className="font-serif" style={{ fontSize: "1.7rem", lineHeight: 1.15, marginBottom: "1rem", color: "var(--text)" }}>{post.title}</h2>
        <div className="blog-body" style={{ color: "var(--muted)", fontSize: "0.92rem", lineHeight: 1.8 }} dangerouslySetInnerHTML={{ __html: post.body_html }} />
        <button className="btn-gold" data-testid="weekly-popup-cta" style={{ marginTop: "1.6rem", width: "100%" }} onClick={dismiss}>Got it — show me the deals</button>
      </div>
    </div>
  );
}
